﻿import { useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Form, Button } from "react-bootstrap";
import CustomInputSwitch from "@/components/desktop/form/input/input-switch/CustomInputSwitch";
import Select from "react-select";
import _ from "lodash";

import classes from "./inventory.module.scss";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const InventoryFilter = ({ base, applyFilter }) => {
	const { aptitudes, cas, formulas, business } = useSelector((state) => state.inventory);

	const { user } = useSelector((state) => state.auth);

	const [defaultUnitFilter, setDefaultUnitFilter] = useState(base.defaultUnit);
	const [aptitudeFilter, setAptitudeFilter] = useState(base.aptitudeID);
	const [casFilter, setCasFilter] = useState(base.cas);
	const [formulaFilter, setFormulaFilter] = useState(base.formula);
	const [dateFilter, setDateFilter] = useState(base.createdDate);
	const [dateToFilter, setDateToFilter] = useState(base.createdDateTo);
	const [showUsageFilter, setShowUsageFilter] = useState(base.showUsage);
	const [showGenericFilter, setShowGenericFilter] = useState(base.showGeneric);
	const [businessFilter, setBusinessFilter] = useState(base.selectedBusiness);
	const [expiredFilter, setExpiredFilter] = useState(base.expired);
	const [showInitiallyLoadedFilter, setShowInitiallyLoadedFilter] = useState(base.showInitiallyLoaded);

	const handleApplyFilter = () => {
		applyFilter({
			defaultUnitFilter,
			aptitudeFilter,
			dateFilter,
			dateToFilter,
			casFilter,
			formulaFilter,
			showUsageFilter,
			showGenericFilter,
			businessFilter,
			expiredFilter,
			showInitiallyLoadedFilter,
		});
	};

	const handleCleanFilter = () => {
		applyFilter({
			defaultUnitFilter: 1000,
			aptitudeFilter: "",
			dateFilter: "",
			dateToFilter: "",
			showUsageFilter: true,
			showInitiallyLoadedFilter: false,
			businessFilter: "",
			expiredFilter: true,
		});
	};

	const baseUnits = [
		{ value: 1, label: "g - cc" },
		{ value: 1000, label: "Kg - L" },
		{ value: 10000, label: "Tn - KL" },
	];

	return (
		<Col md={3} className={classes.filter}>
			<h4 className={classes.filterTitle}>Filtros</h4>
			<hr className={classes.filterHr} />

			<div className={classes.divContent}>
				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Unidad de Medida</span>
					</Col>
					<Col md={12}>
						<Select
							value={baseUnits && baseUnits.filter((b) => Number(b.value) === Number(defaultUnitFilter))}
							placeholder={<div>Seleccione</div>}
							options={baseUnits ? baseUnits : []}
							onChange={(value) => setDefaultUnitFilter(value.value)}
							components={{ NoOptionsMessage }}
							menuPlacement="auto"
						/>
					</Col>
				</Row>
				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Aptitud</span>
					</Col>
					<Col md={12}>
						<Select
							value={
								aptitudes &&
								aptitudes.filter(
									(a) => aptitudeFilter && aptitudeFilter.length > 0 && _.map(aptitudeFilter.split(","), Number).includes(Number(a.value)),
								)
							}
							isMulti
							placeholder={<div>Seleccione</div>}
							options={aptitudes ? aptitudes : []}
							onChange={(value) => {
								let baseValue = [];
								value.forEach((element) => {
									baseValue.push(element.value);
								});

								setAptitudeFilter(baseValue.length !== 0 ? baseValue.toString() : "");
							}}
							components={{ NoOptionsMessage }}
							menuPlacement="auto"
						/>
					</Col>
				</Row>
				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Razón social</span>
					</Col>
					<Col md={12}>
						<Select
							value={
								business &&
								business.filter(
									(b) => businessFilter && businessFilter.length > 0 && _.map(businessFilter.split(","), Number).includes(Number(b.value)),
								)
							}
							isMulti
							placeholder={<div>Seleccione</div>}
							options={business ? business : []}
							onChange={(value) => {
								let baseValue = [];
								value.forEach((element) => {
									baseValue.push(element.value);
								});

								setBusinessFilter(baseValue.length !== 0 ? baseValue.toString() : "");
							}}
							components={{ NoOptionsMessage }}
							menuPlacement="auto"
						/>
					</Col>
				</Row>
				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Fecha Ingreso</span>
					</Col>
					<Col md={12}>
						<small>Desde</small>
						<Form.Control
							type="text"
							name="created_at"
							placeholder=" "
							value={dateFilter}
							onChange={(e) => setDateFilter(e.target.value)}
							onFocus={(e) => (e.target.type = "date")}
						/>
					</Col>
					<Col md={12}>
						<small>Hasta</small>
						<Form.Control
							type="text"
							name="created_at"
							placeholder=" "
							value={dateToFilter}
							onChange={(e) => setDateToFilter(e.target.value)}
							onFocus={(e) => (e.target.type = "date")}
						/>
					</Col>
				</Row>
				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Ver Productos fuera de Bodega</span>
					</Col>
					<Col md={12} style={{ textAlign: "center", marginBottom: "10px" }}>
						<CustomInputSwitch
							value={showUsageFilter}
							optionLeft="NO"
							optionRight="SI"
							onChange={(checked) => {
								setShowUsageFilter(checked);
							}}
						/>
					</Col>
				</Row>
				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Ver Productos Vencidos</span>
					</Col>
					<Col md={12} style={{ textAlign: "center", marginBottom: "10px" }}>
						<CustomInputSwitch
							value={expiredFilter}
							optionLeft="NO"
							optionRight="SI"
							onChange={(checked) => {
								setExpiredFilter(checked);
							}}
						/>
					</Col>
				</Row>
				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Ver Solo Genéricos</span>
					</Col>
					<Col md={12} style={{ textAlign: "center", marginBottom: "10px" }}>
						<CustomInputSwitch
							value={showGenericFilter}
							optionLeft="NO"
							optionRight="SI"
							onChange={(checked) => {
								setShowGenericFilter(checked);
							}}
						/>
					</Col>
				</Row>
				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Ver Solo Carga Inicial</span>
					</Col>
					<Col md={12} style={{ textAlign: "center", marginBottom: "10px" }}>
						<CustomInputSwitch
							value={showInitiallyLoadedFilter}
							optionLeft="NO"
							optionRight="SI"
							onChange={(checked) => {
								setShowInitiallyLoadedFilter(checked);
							}}
						/>
					</Col>
				</Row>
				{user && user.customer && Number(user.customer.id) === 15 && (
					<>
						<Row className={classes.divForm}>
							<Col md={12} className={classes.divLabel}>
								<span className={classes.label}>Cas</span>
							</Col>
							<Col md={12}>
								<Select
									value={cas && cas.filter((a) => casFilter && casFilter.length > 0 && _.map(casFilter.split(",")).includes(a.value))}
									isMulti
									placeholder={<div>Seleccione</div>}
									options={cas ? cas : []}
									onChange={(value) => {
										let baseValue = [];
										value.forEach((element) => {
											baseValue.push(element.value);
										});

										setCasFilter(baseValue.length !== 0 ? baseValue.toString() : "");
									}}
									components={{ NoOptionsMessage }}
									menuPlacement="auto"
								/>
							</Col>
						</Row>

						<Row className={classes.divForm} style={{ paddingBottom: "2em" }}>
							<Col md={12} className={classes.divLabel}>
								<span className={classes.label}>Fórmula</span>
							</Col>
							<Col md={12}>
								<Select
									value={
										formulas &&
										formulas.filter((a) => formulaFilter && formulaFilter.length > 0 && _.map(formulaFilter.split(",")).includes(a.value))
									}
									isMulti
									placeholder={<div>Seleccione</div>}
									options={formulas ? formulas : []}
									onChange={(value) => {
										let baseValue = [];
										value.forEach((element) => {
											baseValue.push(element.value);
										});

										setFormulaFilter(baseValue.length !== 0 ? baseValue.toString() : "");
									}}
									components={{ NoOptionsMessage }}
									menuPlacement="auto"
								/>
							</Col>
						</Row>
					</>
				)}
			</div>

			<div className={classes.divFooter}>
				<Button className={classes.buttonClean} onClick={() => handleCleanFilter()}>
					Limpiar
				</Button>

				<Button className={classes.buttonApply} onClick={() => handleApplyFilter()}>
					Aplicar
				</Button>
			</div>
		</Col>
	);
};

export default InventoryFilter;
